import { render, staticRenderFns } from "./OrderablePreviewCustomer.vue?vue&type=template&id=c04a5c0e&"
import script from "./OrderablePreviewCustomer.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports